import { RingBuffer } from './ring-buffer';
import type { BreadcrumbEntry } from './types';

export class BreadcrumbBuffer {
  private buffer: RingBuffer<BreadcrumbEntry>;
  private clickHandler: ((e: MouseEvent) => void) | null = null;
  private submitHandler: ((e: SubmitEvent) => void) | null = null;
  private installed = false;

  constructor(bufferSize = 50) {
    this.buffer = new RingBuffer(bufferSize);
  }

  install(): void {
    if (this.installed) return;
    this.installed = true;

    this.clickHandler = (e: MouseEvent) => {
      const target = e.target as HTMLElement | null;
      if (!target) return;

      const tracked = target.closest('[data-track]') as HTMLElement | null;
      if (!tracked) return;

      this.buffer.push({
        ts: new Date().toISOString(),
        type: 'click',
        target: tracked.getAttribute('data-track') || tracked.tagName.toLowerCase(),
      });
    };

    this.submitHandler = (e: SubmitEvent) => {
      const form = e.target as HTMLFormElement | null;
      this.buffer.push({
        ts: new Date().toISOString(),
        type: 'form_submit',
        target: form?.getAttribute('data-track') || form?.id || undefined,
      });
    };

    document.addEventListener('click', this.clickHandler, { capture: true, passive: true });
    document.addEventListener('submit', this.submitHandler, { capture: true, passive: true });
  }

  addNavigation(route: string): void {
    this.buffer.push({
      ts: new Date().toISOString(),
      type: 'navigation',
      route,
    });
  }

  getAll(): BreadcrumbEntry[] {
    return this.buffer.getAll();
  }

  clear(): void {
    this.buffer.clear();
  }

  destroy(): void {
    if (!this.installed) return;
    if (this.clickHandler) {
      document.removeEventListener('click', this.clickHandler, { capture: true } as EventListenerOptions);
      this.clickHandler = null;
    }
    if (this.submitHandler) {
      document.removeEventListener('submit', this.submitHandler, { capture: true } as EventListenerOptions);
      this.submitHandler = null;
    }
    this.installed = false;
  }
}
